import styled, { css } from 'styled-components';
import { Form } from 'formik';
import { breakpoints, font, spacing } from '@chegg-ui/theme';
import { Typography } from '@chegg-ui/typography';
import { Tabs as CheggUiTabs } from '@chegg-ui/tabs';
export var WritingFormsContainer = styled(Form).withConfig({
  componentId: "gaf891-0"
})(["margin:0;font-family:", ";width:'100%';height:inherit;"], font.family["default"]);
export var FormHeading = styled(Typography).attrs({
  variant: 'h3'
}).withConfig({
  componentId: "gaf891-1"
})(["font-size:", ";margin:", ";@media screen and (max-width:", "){margin:", ";}"], font.size.px22, function (props) {
  return props.adsEnabled ? "".concat(spacing.px16, " ").concat(spacing.px24, " ").concat(spacing.px12) : "".concat(spacing.px32, " ").concat(spacing.px32, " ").concat(spacing.px12);
}, breakpoints.md.max, function (props) {
  return props.adsEnabled ? "".concat(spacing.px16, " ").concat(spacing.px16, " 0") : "".concat(spacing.px32, " ").concat(spacing.px16, " 0");
});
export var FormWrapper = styled.div.withConfig({
  componentId: "gaf891-2"
})(["overflow:auto;height:calc(100% - 120px);padding:6px ", " 0;@media screen and (max-width:", "){padding:6px ", " 0;}", ""], function (props) {
  return props.adsEnabled ? spacing.px24 : spacing.px32;
}, breakpoints.md.max, spacing.px16, function (props) {
  return props.showButtonsInVertical ? css(["@media screen and (max-width:", ") and (min-width:", "){height:calc(100% - 182px);}@media screen and (max-width:400px){height:calc(100% - 170px);}"], breakpoints.lg.max, breakpoints.md.min) : "";
});
export var Tabs = styled(CheggUiTabs).withConfig({
  componentId: "gaf891-3"
})(["& > div:first-child{margin:", " 0px ", ";}"], spacing.px12, spacing.px16);
export var RadioGroupWrapper = styled.div.withConfig({
  componentId: "gaf891-4"
})(["width:'100%';"]);